if (!window.Decimal) {
    window.Decimal = require('decimal.js-light');
}
